import { render, staticRenderFns } from "./ProductHeader.vue?vue&type=template&id=c0543772&scoped=true&"
import script from "./ProductHeader.vue?vue&type=script&lang=js&"
export * from "./ProductHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProductHeader.vue?vue&type=style&index=0&id=c0543772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0543772",
  null
  
)

export default component.exports